<!--suppress ALL -->
<template>
  <div>
    <div class="padding15">
      <el-form size="small" label-width="100px" ref="searchRef">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="一级意图">
              <el-input
                v-model="searchReq.intention1"
                placeholder="请输入一级意图名称"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="一级意图备注">
              <el-input
                v-model="searchReq.intention1Remark"
                placeholder="请输入一级意图备注"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="二级意图">
              <el-input
                v-model="searchReq.intention2"
                placeholder="请输入二级意图名称"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="二级意图备注">
              <el-input
                v-model="searchReq.intention2Remark"
                placeholder="请输入二级意图备注"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="创建时间">
              <el-date-picker v-model="searchReq.startTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="至">
              <el-date-picker v-model="searchReq.endTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
          <!-- 按钮操作 -->
          <div class="text right">
            <el-button :disabled="noAdd" type="primary" size="small" plain @click="searchReq.page = 1; getList();"><i class="fa fa-search"></i> 搜索</el-button>
            <el-button :disabled="noAdd" size="small" @click="reset">重置</el-button>
          </div>
        </el-row>
      </el-form>
    </div>
    <div class="bg-content">
      <el-button
        type="primary"
        icon="el-icon-plus"
        size="mini"
        :disabled="noAdd"
        @click="handleAdd"
      >新增</el-button>
      <el-button
        type="danger"
        icon="el-icon-delete"
        size="mini"
        :disabled="multiple"
        @click="handleDelByIds"
      >删除</el-button>
      <br/><br/>
      <el-table size="small" :data="conditionList.list" v-loading="loading" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column fixed property="confName"  label="意图包名称"  align="center"/>
        <el-table-column fixed property="intention1"  label="一级意图"  align="center"/>
        <el-table-column fixed property="intention1Remark"  label="一级意图备注"  align="center"/>
        <el-table-column fixed label="二级意图" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-button type="text" @click="linkConIndex(scope.row)">{{scope.row.intention2}}</el-button>
          </template>
        </el-table-column>
        <el-table-column fixed property="intention2Remark"  label="二级意图备注"  align="center"/>
        <el-table-column fixed property="priority"  label="案件意图优先级"  align="center"/>
        <el-table-column fixed property="conPriority"  label="通话意图优先级"  align="center"/>
        <el-table-column fixed property="createTime"  label="创建时间"  align="center"/>
        <el-table-column fixed label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="updateButton(scope.row)"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
            <el-button type="text" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="text center margin15-tb">
        <el-pagination
          background
          layout="prev, pager, next, sizes, total"
          :total="conditionList.totalRecords"
          :page-size="searchReq.limit"
          :current-page="searchReq.page"
          @current-change="currentChange"
          @size-change="sizeChange">
        </el-pagination>
      </div>
    </div>
    <!--    编辑    -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="所属意图包">
          <el-input v-model="form.confName" style="width: 80%;" :disabled="true" />
        </el-form-item>
        <el-form-item label="一级意图" prop="intention1">
          <el-input v-model="form.intention1" placeholder="请输入一级意图" style="width: 80%;" :disabled="isUpdate"/>
        </el-form-item>
        <el-form-item label="一级意图备注" prop="intention1Remark">
          <el-input v-model="form.intention1Remark" placeholder="请输入一级意图备注" style="width: 80%;" :disabled="isUpdate"/>
        </el-form-item>
        <el-form-item label="二级意图" prop="intention2">
          <el-input v-model="form.intention2" placeholder="请输入二级意图" style="width: 80%;" :disabled="isUpdate"/>
        </el-form-item>
        <el-form-item label="二级意图备注" prop="intention2Remark">
          <el-input v-model="form.intention2Remark" placeholder="请输入二级意图备注" style="width: 80%;" :disabled="isUpdate"/>
        </el-form-item>
        <el-form-item label="案件意图优先级" prop="priority">
            <el-input-number v-model.number="form.priority" :min="1" :max="999" style="width: 80%;" :step="1"/>
        </el-form-item>
        <el-form-item label="通话意图优先级" prop="conPriority">
            <el-input-number v-model.number="form.conPriority" :min="1" :max="999" style="width: 80%;" :step="1"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确认</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    changeTabe: {
      type: String
    }
  },
  watch: {
    changeTabe(type) {
      if (type === '意图配置') {
        this.confId = sessionStorage.getItem('changeConfId');
        this.confName = sessionStorage.getItem('intentionConfName');
        if (this.confId != null && undefined !== this.confId && this.confId !== '') {
          this.noAdd = false;
          this.getList();
        }
      }
    }
  },
  data() {
    return {
      loading: false,
      searchReq: {
        intention1: null,
        intention2: null,
        startTime: null,
        endTime: null,
        page: 1,
        limit: 10,
        order: 'create_time',
        sort: 'desc'
      },
      conditionList: { 'totalRecords': 0, list: [] },
      // 表单参数
      form: {
        priority: 1,
        conPriority: 1,
        confName: null,
        intention1: null,
        intention1Remark: null,
        intention2: null,
        intention2Remark: null
      },
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 上层的意图包基本信息id
      confId: null,
      // 上层意图包名称
      confName: null,
      // 是否为编辑
      isUpdate: false,
      // 是否能添加
      noAdd: true
    };
  },
  mounted() {
  },
  methods: {
    getList() {
      this.loading = true;
      this.searchReq.confId = this.confId;
      this.$ajax({
        method: 'get',
        url: '/intentionDetail/list',
        params: this.searchReq
      }).then((res) => {
        this.conditionList.list = res.data.list;
        this.conditionList.totalRecords = res.data.totalRecords;
        this.loading = false;
      });
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    updateButton(row) {
      this.title = '编辑意图';
      this.form.id = row.id;
      this.form.confId = row.confId;
      this.form.intention1 = row.intention1;
      this.form.intention1Remark = row.intention1Remark;
      this.form.intention2 = row.intention2;
      this.form.intention2Remark = row.intention2Remark;
      this.form.priority = row.priority;
      this.form.conPriority = row.conPriority;
      this.form.confName = row.confName;
      this.open = true;
      this.isUpdate = true;
    },
    handleAdd() {
      this.title = '添加意图';
      this.form.id = null;
      this.form.confId = this.confId;
      this.form.intention1 = null;
      this.form.intention1Remark = null;
      this.form.intention2 = null;
      this.form.intention2Remark = null;
      this.form.priority = 1;
      this.form.conPriority = 1;
      this.open = true;
      this.isUpdate = false;
      this.form.confName = this.confName;
    },
    // 重置
    reset() {
      this.searchReq.intention1 = null;
      this.searchReq.intention2 = null;
      this.searchReq.startTime = null;
      this.searchReq.endTime = null;
    },
    currentChange(page) {
      this.searchReq.page = page;
      this.getList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.getList();
    },
    submitForm() {
      if (this.form.id) {
        this.$ajax({
          method: 'post',
          url: '/intentionDetail/update',
          data: this.form
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
            this.open = false;
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        });
      } else {
        this.$confirm('意图一旦创建不可编辑，确定要保存吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.$ajax({
            method: 'post',
            url: '/intentionDetail/save',
            data: this.form
          }).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '成功!'
              });
              this.open = false;
              this.getList();
            } else {
              this.$message({
                type: 'error',
                message: '失败!'
              });
            }
          });
        });
      }
    },
    cancel() {
      this.open = false;
      this.reset();
    },
    handleDelByIds() {
      this.$confirm('是否确认删除 ?', '警告', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method: 'delete',
          url: '/intentionDetail/del',
          data: this.ids
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        }).finally(() => {
          this.getList();
        });
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm(`是否确认删除目标策略：${row.intention2} ?`, '警告', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method: 'delete',
          url: `/intentionDetail/del/${row.id}`
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        }).finally(() => {
          this.getList();
        });
      });
    },
    linkConIndex(row) {
      sessionStorage.setItem('changeDetailId', row.id);
      this.$emit('showbox', '意图规则');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/collection/intention/detail/detail_index.vue